<template>
  <div class="md-layout search-area">
    <md-card>
      <md-card-header md-alignment="space-between">
        <h4 class="title"><md-icon>search</md-icon>검색 조건</h4>
      </md-card-header>
      <md-card-content>
        <table class="flex-table">
          <colgroup>
            <col width="4%" />
            <col width="16%" />
            <col width="" />
            <col width="" />
            <col width="" />
            <col width="" />
            <col width="" />
            <col width="" />
            <col width="" />
            <col width="" />
          </colgroup>
          <tr>
            <th>구분</th>
            <td>
              <div class="inline-flex">
                <label
                  ><input
                    type="radio"
                    value=""
                    v-model="searchQuery.applyGb"
                    name="applyGb"
                    v-on:keyup.enter="sendQuery"
                  />전체</label
                >
                <label
                  ><input
                    type="radio"
                    value="1"
                    v-model="searchQuery.applyGb"
                    name="applyGb"
                    v-on:keyup.enter="sendQuery"
                  />개인명의</label
                >
                <label
                  ><input
                    type="radio"
                    value="2"
                    v-model="searchQuery.applyGb"
                    name="applyGb"
                    v-on:keyup.enter="sendQuery"
                  />교우자녀</label
                >
                <label
                  ><input
                    type="radio"
                    value="3"
                    v-model="searchQuery.applyGb"
                    name="applyGb"
                    v-on:keyup.enter="sendQuery"
                  />교우회(장학)</label
                >
              </div>
            </td>
            <th>대상학기</th>
            <td>
              <select v-model="searchQuery.semesterCd" name="semesterCd">
                <option value="">선택</option>
                <option
                  v-for="item in semesterCdList"
                  :key="item.code"
                  :label="item.codeNm"
                  :value="item.code"
                >
                  {{ item }}
                </option>
              </select>
            </td>
            <th>대학</th>
            <td>
              <input
                type="text"
                v-model="searchQuery.collegeMCd"
                v-on:keyup.enter="sendQuery"
              />
            </td>
            <th>학과</th>
            <td>
              <input
                type="text"
                v-model="searchQuery.collegeSCd"
                v-on:keyup.enter="sendQuery"
              />
            </td>
            <th>학번</th>
            <td>
              <input
                type="text"
                v-model="searchQuery.hakbun"
                v-on:keyup.enter="sendQuery"
              />
            </td>
          </tr>
          <tr>
            <th>성별</th>
            <td>
              <div class="inline-flex">
                <label
                  ><input
                    type="radio"
                    value=""
                    v-model="searchQuery.sex"
                    name="sex"
                    v-on:keyup.enter="sendQuery"
                  />전체</label
                >
                <label
                  ><input
                    type="radio"
                    value="M"
                    v-model="searchQuery.sex"
                    name="sex"
                    v-on:keyup.enter="sendQuery"
                  />남</label
                >
                <label
                  ><input
                    type="radio"
                    value="F"
                    v-model="searchQuery.sex"
                    name="sex"
                    v-on:keyup.enter="sendQuery"
                  />여</label
                >
              </div>
            </td>
            <th>연락처</th>
            <td>
              <input
                type="text"
                v-model="searchQuery.phoneNo1"
                v-on:keyup.enter="sendQuery"
              />
            </td>
            <th>전 학기성적</th>
            <td>
              <div class="inline-flex">
                <input type="text" v-model="searchQuery.fromPrevAvgHakjum" />
                <span>~</span>
                <input
                  type="text"
                  v-model="searchQuery.toPrevAvgHakjum"
                  v-on:keyup.enter="sendQuery"
                />
              </div>
            </td>
            <th>전전 학기성적</th>
            <td>
              <div class="inline-flex">
                <input type="text" v-model="searchQuery.fromPrev2AvgHakjum" />
                <span>~</span>
                <input
                  type="text"
                  v-model="searchQuery.toPrev2AvgHakjum"
                  v-on:keyup.enter="sendQuery"
                />
              </div>
            </td>
            <th>장학 매칭</th>
            <td>
              <div class="inline-flex">
                <label
                  ><input
                    type="radio"
                    value=""
                    v-model="searchQuery.matchingYn"
                    name="matchingYn"
                    v-on:keyup.enter="sendQuery"
                  />전체</label
                >
                <label
                  ><input
                    type="radio"
                    value="Y"
                    v-model="searchQuery.matchingYn"
                    name="matchingYn"
                    v-on:keyup.enter="sendQuery"
                  />유</label
                >
                <label
                  ><input
                    type="radio"
                    value="N"
                    v-model="searchQuery.matchingYn"
                    name="matchingYn"
                    v-on:keyup.enter="sendQuery"
                  />무</label
                >
              </div>
            </td>
          </tr>
          <tr>
            <th>캠퍼스</th>
            <td>
              <div class="inline-flex">
                <label
                  ><input
                    type="radio"
                    value=""
                    v-model="searchQuery.collegeLCd"
                    name="collegeLCd"
                    v-on:keyup.enter="sendQuery"
                  />전체</label
                >
                <label
                  ><input
                    type="radio"
                    value="0001"
                    v-model="searchQuery.collegeLCd"
                    name="collegeLCd"
                    v-on:keyup.enter="sendQuery"
                  />서울</label
                >
                <label
                  ><input
                    type="radio"
                    value="0002"
                    v-model="searchQuery.collegeLCd"
                    name="collegeLCd"
                    v-on:keyup.enter="sendQuery"
                  />세종</label
                >
              </div>
            </td>
            <th>성명</th>
            <td>
              <input
                type="text"
                v-model="searchQuery.nm"
                v-on:keyup.enter="sendQuery"
              />
            </td>
            <th>학년</th>
            <td colspan="5">
              <div>
                <label
                  ><input
                    type="checkbox"
                    value=""
                    v-model="selectAll"
                  />전체</label
                >
                <label v-for="item in clgSemesterCdList" v-bind:key="item.code"
                  ><input
                    type="checkbox"
                    :key="item.code"
                    :value="item.code"
                    v-model="checkedClgSemesterCdList"
                  />{{ item.codeNm }}</label
                >
              </div>
            </td>
          </tr>
        </table>
      </md-card-content>
      <md-card-actions md-alignment="right">
        <md-button class="md-info md-sm" @click="sendQuery">
          <md-icon>check</md-icon>검 색
        </md-button>
        <md-button class="md-default md-sm" @click="resetQuery">
          <md-icon>clear</md-icon>초기화
        </md-button>
        <md-button
          class="md-success md-sm"
          :disabled="this.pagination.total === 0"
          @click="downloadExcel"
          v-exel-btn="[5, 3]"
        >
          <md-icon>get_app</md-icon>Excel 다운로드
        </md-button>
        <!--          <md-button class="md-info md-sm">-->
        <!--            <md-icon>check</md-icon>-->
        <!--            장학 매칭-->
        <!--          </md-button>-->
        <md-button
          class="md-warning md-sm"
          :disabled="this.pagination.total === 0"
          @click="deleteRow"
        >
          <md-icon>clear</md-icon>삭제
        </md-button>

        <md-button class="md-success md-sm" @click="isModalShow = true">
          <md-icon>publish</md-icon>
          엑셀 업로드
        </md-button>
      </md-card-actions>
    </md-card>

    <md-card>
      <md-card-header md-alignment="space-between">
        <h4 class="title">
          <md-icon>assignment</md-icon>
          검색 결과
        </h4>
      </md-card-header>
      <md-card-content>
        <div class="table-header-info">
          <div>총 {{ total }} 건의 검색결과가 있습니다.</div>
          <div>
            <select
              v-model="pagination.perPage"
              name="pages"
              @change="perPageChange"
            >
              <option
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
              >
                {{ item }}
              </option>
            </select>
          </div>
        </div>

        <grid
          ref="ApplyDonorList"
          :data="gridProps.data"
          :columns="gridProps.columns"
          :options="gridProps.options"
          :header="gridProps.header"
          :theme="gridProps.theme"
          :rowHeaders="gridProps.rowHeaders"
          :columnOptions="gridProps.columnOptions"
          :language="gridProps.lang"
          @click="onClickRow"
          @response="response"
        ></grid>
      </md-card-content>
    </md-card>

    <!-- 신청자 엑셀 업로드 -->
    <apply-excel-upload-comp
      :is-show.sync="isModalShow"
    ></apply-excel-upload-comp>
  </div>
</template>
<script>
import Vue from "vue";
import formatter from "@/kuaa/kuaa-formatter";
import kuaaApi from "@/kuaa/kuaa-api";
import URL_CONST from "@/kuaa/kuaa-url-const";
import kuaaFnc from "@/kuaa/kuaa-comm-func";
import session from "@/kuaa/kuaa-sessions";

import Swal from "sweetalert2";
import moment from "moment";

import ApplyExcelUploadComp from "@/pages/Scholarship/Components/ApplyExcelUploadComp";

import { Grid } from "@toast-ui/vue-grid";
import "tui-grid/dist/tui-grid.css";
import "tui-pagination/dist/tui-pagination.css";

export default {
  name: "ApplyDonorListComp",

  props: {},

  components: {
    grid: Grid,
    ApplyExcelUploadComp
  },

  created() {
    this.getSemesterCdList();
    this.getClgSemesterCdList();
    this.initGrid();
  },

  computed: {
    total() {
      return this.pagination.total;
    },
    selectAll: {
      get: function() {
        return false;
      },
      set: function(value) {
        let selected = [];

        if (value) {
          this.clgSemesterCdList.forEach(function(obj) {
            selected.push(obj.code);
          });
        }

        this.checkedClgSemesterCdList = selected;
      }
    }
  },
  data() {
    return {
      searchQuery: {
        applyGb: "",
        semesterCd: this.$route.query.semesterCd,
        collegeMCd: null,
        collegeSCd: null,
        collegeSemesterCd: [],
        hakbun: null,
        nm: this.$route.query.nm,
        sex: "",
        phoneNo1: null,
        fromPrevAvgHakjum: null,
        toPrevAvgHakjum: null,
        fromPrev2AvgHakjum: null,
        toPrev2AvgHakjum: null,
        matchingYn: ""
      },
      semesterCdList: [],
      clgSemesterCdList: [],
      checkedClgSemesterCdList: [],
      gridProps: {},
      pagination: {
        perPage: 500,
        page: 1,
        perPageOptions: [800, 500, 200, 100, 50, 20],
        total: 0
      },
      isModalShow: false
    };
  },
  mounted() {
    if (this.$route.query.semesterCd) {
      this.sendQuery();
    }
  },
  methods: {
    getSemesterCdList() {
      kuaaFnc.fncSemesterCodes(null, res => {
        this.semesterCdList = res.data.data.contents;
      });
    },
    getClgSemesterCdList() {
      kuaaFnc.fncClgSemesterCdList(null, res => {
        this.clgSemesterCdList = res.data.data.contents;
      });
    },
    resetQuery() {
      this.selectAll = false;
      this.searchQuery = {
        applyGb: "",
        semesterCd: "",
        collegeMCd: null,
        collegeSCd: null,
        collegeSemesterCd: [],
        hakbun: null,
        nm: null,
        sex: "",
        phoneNo1: null,
        fromPrevAvgHakjum: null,
        toPrevAvgHakjum: null,
        fromPrev2AvgHakjum: null,
        toPrev2AvgHakjum: null,
        matchingYn: ""
      };
    },
    sendQuery() {
      this.searchQuery.collegeSemesterCd = this.checkedClgSemesterCdList;
      this.$refs.ApplyDonorList.invoke("readData", 1, this.searchQuery);
    },

    initGrid() {
      let _this = this;

      this.gridProps = kuaaFnc.setGridInit(
        URL_CONST.GET_SCHA_APPLY_LIST,
        false,
        this.pagination,
        ["rowNum", "checkbox"]
      );
      this.gridProps["el"] = this.$refs.ApplyDonorList;
      this.gridProps["options"].rowHeight = 25;
      this.gridProps["options"].useClientSort = true; // 클라이언트 정렬 활성화
      this.gridProps["header"].height = 62;
      // this.gridProps["header"].align = "left";
      this.gridProps["header"].complexColumns = [
        // {
        //   header: "신청",
        //   name: "applyGbNm_merge",
        //   childNames: ["applyGbNm"]
        // },
        // {
        //   header: "재산세",
        //   name: "merge1",
        //   childNames: ["A"]
        // },
        // {
        //   header: "건보료",
        //   name: "merge2",
        //   childNames: ["B"]
        // },
        // {
        //   header: "연소득",
        //   name: "merge3",
        //   childNames: ["C"]
        // },
        {
          header: "구간",
          name: "merge9",
          childNames: ["A"]
        },
        {
          header: "성적",
          name: "merge4",
          childNames: ["B"]
        },
        {
          header: "알바",
          name: "merge5",
          childNames: ["C"]
        },
        {
          header: "구성원",
          name: "merge6",
          childNames: ["D"]
        },
        {
          header: "경제주",
          name: "merge7",
          childNames: ["E"]
        },
        {
          header: "회비",
          name: "merge8",
          childNames: ["F"]
        },
        {
          header: "학업성적",
          name: "merge10",
          childNames: ["grade1CdNm", "grade2CdNm"]
        },
        {
          header: "부모",
          name: "merge11",
          childNames: ["parentClassCdNm", "parentHakbun"]
        }
      ];
      this.gridProps["columns"] = [
        {
          header: "대상학기",
          name: "semesterCdNm",
          align: "center",
          width: 100,
          sortable: true
        },
        {
          header: "신청구분",
          name: "applyGbNm",
          align: "center",
          width: 80,
          sortable: true
        },
        {
          header: "캠퍼스구분",
          name: "collegeLCdNm",
          align: "center",
          width: 90,
          sortable: true
        },
        {
          header: "대학",
          name: "collegeMCdNm",
          align: "center",
          width: 100,
          sortable: true
        },
        { header: "학과", name: "collegeSCdNm", width: 130, sortable: true },
        {
          header: "학년",
          name: "collegeSemesterCdNm",
          align: "center",
          width: 80,
          sortable: true
        },
        {
          header: "학번",
          name: "hakbun",
          align: "center",
          width: 90,
          sortable: true
        },
        {
          header: "성명",
          name: "nm",
          align: "center",
          sortable: true,
          formatter(value) {
            return `<span style="color:#0091d5; cursor:pointer;">${value.value}</a>`;
          }
        },
        { header: "성별", name: "sex", align: "center", sortable: true },
        {
          header: "연락처",
          name: "phoneNo1",
          align: "center",
          width: 100,
          sortable: true
        },
        {
          header: "전화번호",
          name: "phoneNo2",
          align: "center",
          width: 100,
          sortable: true
        },
        { header: "이메일", name: "eMail", width: 140, sortable: true },
        {
          header: "총이수학기",
          name: "completeSemester",
          align: "center",
          width: 100,
          sortable: true
        },
        {
          header: "총이수학점",
          name: "completeHakjum",
          align: "center",
          width: 100,
          sortable: true
        },
        {
          header: "선택1",
          name: "grade1CdNm",
          align: "center",
          width: 60,
          sortable: true
        },
        {
          header: "선택2",
          name: "grade2CdNm",
          align: "center",
          width: 120,
          sortable: true
        },
        {
          header: "전전학기평점",
          name: "prev2AvgHakjum",
          align: "center",
          width: 100,
          sortable: true
        },
        {
          header: "전학기평점",
          name: "prevAvgHakjum",
          align: "center",
          width: 100,
          sortable: true
        },
        {
          header: "평균평점",
          name: "avgHakjum",
          align: "center",
          width: 80,
          sortable: true
        },
        {
          header: "교우부모명",
          name: "parentMemberHnm",
          width: 100,
          sortable: true
        },
        // { header: "A", name: "A", align: "center", sortable: true },
        // { header: "B", name: "B", align: "center", sortable: true },
        // { header: "C", name: "C", align: "center", sortable: true },
        { header: "A", name: "A", align: "center", sortable: true },
        { header: "B", name: "B", align: "center", sortable: true },
        { header: "C", name: "C", align: "center", sortable: true },
        { header: "D", name: "D", align: "center", sortable: true },
        { header: "E", name: "E", align: "center", sortable: true },
        { header: "F", name: "F", align: "center", sortable: true },
        {
          header: "계",
          name: "pointTotal",
          align: "center",
          sortable: true,
          sortingType: "number",
          formatter(value) {
            return formatter.getCurrency(value.value || 0);
          }
        },
        {
          header: "비고",
          name: "applyEtc",
          width: 200,
          align: "center",
          editor: {
            type: "text"
          },
          onAfterChange(e) {
            _this.editRow(e);
          }
        },
        {
          header: "학과",
          name: "parentClassCdNm",
          width: 110,
          sortable: true
        },
        {
          header: "학번",
          name: "parentHakbun",
          align: "center",
          width: 70,
          sortable: true
        },
        { header: "applyGb", name: "applyGb", hidden: true },
        { header: "parentClassCd", name: "parentClassCd", hidden: true },
        { header: "parentCollegeCd", name: "parentCollegeCd", hidden: true }
        //{header: 'parentCollegeCdNm', name: 'parentCollegeCdNm', hidden : true},
        //{header: '이메일2', name: 'eMail2', hidden: true},
        //{header: 'addressGb', name: 'addressGb', hidden: true},
        //{header: 'addressGbNm', name: 'addressGbNm', hidden: true},
        // {
        //   header: '첨부파일', name: 'fileDir', align : 'center',
        //   formatter(value) {
        //     console.log(value)
        //     if(value.value){
        //       return `<a href="${value.value}" target="_blank">첨부파일</a>`;
        //     }else{
        //       return '';
        //     }
        //   }
        // }
      ];
      this.gridProps["columnOptions"].frozenCount = 10;
    },
    perPageChange(event) {
      kuaaFnc.resetPagenation(
        this.$refs.ApplyDonorList,
        event,
        this.pagination
      );
    },
    response(e) {
      let res = JSON.parse(e.xhr.response);
      if (res.result) {
        this.pagination.total = res.data.pagination.totalCount;
        
        // pointTotal 값을 각 row에 직접 계산해서 설정
        this.$nextTick(() => {
          let tempArr = ["A", "B", "C", "D", "E", "F", "G", "H", "N"];
          let rows = this.$refs.ApplyDonorList.invoke("getData");
          rows.forEach((row) => {
            let total = 0;
            tempArr.forEach(t => {
              total += Number(row[t]) || 0;
            });
            row.pointTotal = total;
          });
          // 데이터 다시 설정
          this.$refs.ApplyDonorList.invoke("resetData", rows);
        });
      } else {
        kuaaFnc.gridErrorCallback(e);
      }
      this.$refs.ApplyDonorList.invoke("refreshLayout");
    },
    onClickRow(e) {
      console.log(e);
      if (e.columnName == "applyEtc" || e.columnName == "fileDir") {
      } else if (e.columnName == "nm") {
        if (e.instance.getRow(e.rowKey) != null) {
          this.$emit("returnResult", e.instance.getRow(e.rowKey));
        }
      }
    },
    deleteRow() {
      let rows = this.$refs.ApplyDonorList.invoke("getCheckedRows");

      if (!rows.length) {
        Swal.fire(
          kuaaFnc.getSwalModaloptions({ html: "대상을 선택 해 주세요" })
        );
        return;
      }

      let modalOptions = kuaaFnc.getSwalModaloptions("confirm", {
        html: "삭제 하시겠습니까?"
      });

      Swal.fire(modalOptions).then(result => {
        if (result.value) {
          let params = [];

          rows.forEach(obj => {
            params.push({
              applySeqNo: obj.applySeqNo
            });
          });

          kuaaApi.sendServer(
            URL_CONST.DELETE_SCHA_APPLY_LIST2,
            params,
            "post",
            response => {
              if (response.data.success) {
                Swal.fire(
                  kuaaFnc.getSwalModaloptions({ html: "삭제 되었습니다." })
                );
                this.sendQuery();
              } else {
                Swal.fire(
                  kuaaFnc.getSwalModaloptions({ html: "삭제 실패 하였습니다." })
                );
              }
            }
          );
        }
      });
    },
    editRow(e) {
      let targetRow = this.$refs.ApplyDonorList.invoke("getRow", e.rowKey);

      if (targetRow) {
        let modalOptions = kuaaFnc.getSwalModaloptions();
        kuaaApi.sendServer(
          URL_CONST.UPDATE_SCHA_APPLY_ONE,
          {
            applySeqNo: targetRow.applySeqNo,
            applyEtc: targetRow.applyEtc
          },
          "post",
          response => {
            if (response.data.success) {
              modalOptions.html = `저장 되었습니다.`;
              this.sendQuery();
              Swal.fire(modalOptions);
            } else {
              modalOptions.html = `저장 실패 하였습니다.`;
              Swal.fire(modalOptions);
            }
          }
        );
      }
    },

    downloadExcel() {
      this.searchQuery.page = 1;
      this.searchQuery.perPage = this.pagination.total;
      this.searchQuery.fileName = "신청자 조회";
      kuaaApi.requestFileDownload(
        URL_CONST.SCHA_APPLY_EXCEL_DOWNLOAD,
        this.searchQuery,
        "신청자조회.xlsx",
        response => {
          this.searchQuery.page = this.pagination.page;
          this.searchQuery.perPage = this.pagination.perPage;
        }
      );
    }
  }
};
</script>

<style lang="css" scoped></style>
